import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AccountService } from '@app/_services';

@Component({templateUrl: './paylayout.component.html'})  
export class PaylayoutComponent {

  constructor(
    private router: Router,
    private accountService : AccountService
) {
   if (this.accountService.userValue) {
            this.router.navigate(['/']);
        }
}

}
